import { HeartFilledIcon } from '@calizahq/react-components-v2'
import { Fragment, memo } from 'react'

const MARKER_COLOR = {
  DEFAULT: '#000000',
  ACTIVE: '#194240',
  FAVORITE: '#C62D2C',
}

interface MarkerProps extends React.HTMLAttributes<HTMLElement> {
  isActive?: boolean
  isFavorite?: boolean
  isHovered?: boolean
  lat: number
  lng: number
  onClick?: () => void
  pointCount?: number
}

export const MapMarker = memo(function Marker({
  isActive,
  isFavorite,
  isHovered,
  onClick,
  pointCount,
  ...restHTMLProps
}: MarkerProps): JSX.Element {
  const markerFill =
    isActive || isHovered ? MARKER_COLOR.ACTIVE : isFavorite ? MARKER_COLOR.FAVORITE : MARKER_COLOR.DEFAULT
  const clusterFill = isActive || isHovered ? MARKER_COLOR.ACTIVE : MARKER_COLOR.DEFAULT

  return (
    <div className="absolute" data-testid={restHTMLProps['data-testid']}>
      {pointCount && isFavorite && (
        <div className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full border border-white tag-red-dark">
          <HeartFilledIcon className="w-2.5 text-on-media" />
        </div>
      )}

      <svg
        fill="none"
        height="40"
        onClick={onClick}
        style={{ cursor: 'pointer' }}
        viewBox="0 0 40 40"
        width="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        {pointCount ? (
          <Fragment>
            <circle cx="20" cy="20" fill={clusterFill} r="17" stroke="white" strokeWidth="2"></circle>
            <text className="font-bold text-sm" fill="white" textAnchor="middle" x="50%" y="60%">
              {pointCount}
            </text>
          </Fragment>
        ) : (
          <Fragment>
            <circle
              cx="20"
              cy="20"
              fill={markerFill}
              r={isActive ? 18 : isHovered ? 16 : 12}
              stroke="white"
              strokeWidth="2"
            />
            <circle cx="20" cy="20" fill="white" r="4" />
          </Fragment>
        )}
      </svg>
    </div>
  )
})
